import type { HatoColumnKey, UiPreferences } from "@/features/accounts/api/accountsApi";

// Columnas OCULTABLES de la lista del Hato (spec columnas-hato §3). Tag y
// estado son fijas: sin tag ni estado la lista no sirve. El orden acá define
// el orden de los checkboxes del dropdown.
export const HATO_COLUMN_ORDER: HatoColumnKey[] = ["name", "sex", "lot", "parities"];

export const HATO_COLUMN_LABEL: Record<HatoColumnKey, string> = {
  name: "Nombre",
  sex: "Sexo",
  lot: "Lote",
  parities: "Nº de lactancia",
};

export type HatoVisibleColumns = Record<HatoColumnKey, boolean>;

// Default: todas visibles (incluida Nº lactancia). Llave ausente en las
// preferencias persistidas = visible.
export function resolveHatoColumns(prefs: UiPreferences | undefined): HatoVisibleColumns {
  const stored = prefs?.hatoColumns ?? {};
  return {
    name: stored.name ?? true,
    sex: stored.sex ?? true,
    lot: stored.lot ?? true,
    parities: stored.parities ?? true,
  };
}
